// extracted by mini-css-extract-plugin
module.exports = {"table":"ViewSuppliersTable_table__SFQpu","addSubmitBtn":"ViewSuppliersTable_addSubmitBtn__3sX4b"};